module.exports = __webpack_public_path__ + "img/dark.84a31202.png";